import { Pipe, PipeTransform } from '@angular/core';
import { imgUrl } from '@shared/globals/app-constants';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'getUserPhoto'
})
export class GetUserPhotoPipe implements PipeTransform {
  private environmentUrl = environment.resourcesUrl;

  transform(photo: string): string {
    return photo
      ? photo.includes('http')
        ? photo
        : imgUrl + photo
      : null;
  }
}
